export function areBlockWorkoutsRemoved(originalLayout, newLayout) {
    // Get all cycle numbers from both layouts
    const originalCycles = Object.keys(originalLayout).map(Number);
    const newCycles = Object.keys(newLayout).map(Number);
    // Check if any cycles were completely removed
    const removedCycles = originalCycles.filter((cycle) => !newCycles.includes(cycle));
    if (removedCycles.length > 0) {
        return true;
    }
    // Check if any cycles had their session count reduced
    for (const cycle of newCycles) {
        const originalSessionCount = originalLayout[cycle];
        const newSessionCount = newLayout[cycle];
        if (originalSessionCount &&
            newSessionCount &&
            newSessionCount < originalSessionCount) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=block-workouts-removed.js.map